<div class="file-import-dropzone">
    <ngx-dropzone [multiple]="false" accept="text/csv, text/plain, .csv" (change)="onFileAdded($event)" #dropzone>
        <ngx-dropzone-label>Drag a file or click here to upload</ngx-dropzone-label>
        @if (file(); as file) {
            <ngx-dropzone-preview [removable]="true" [file]="file" (removed)="onFileRemoved()">
                <ngx-dropzone-label>{{ file.name }}</ngx-dropzone-label>
            </ngx-dropzone-preview>
        }
    </ngx-dropzone>
</div>
<div class="file-import-footer">
    <button mat-raised-button color="basic" (click)="onDownload()" type="button">Download</button>
    <button mat-raised-button color="primary" (click)="dropzone.showFileSelector()" type="button">Import</button>
</div>
